import Vue from "vue";
import api from "@/services/api";
import store from "@/store";

import Explorer from "@/Explorer";
import App from "@/App";
import GreenStats from "@/components/green/GreenStats.vue";
import CovidFlightsReplay from "@/components/flights-replay/CovidFlightsReplay";

Vue.prototype.$api = api;

Vue.component("explorer", Explorer);
Vue.component("app", App);
Vue.component("green-stats", GreenStats);
Vue.component("flights-replay", CovidFlightsReplay);

if (document.getElementById("app")) {
  new Vue({
    store,
    el: "#app",
  });
}
